import { Box, IconButton, Grid, Card, Paper } from "@mui/material";
import ModalSys from "../modal";
import setImageManual from "../../hooks/setImageManual"
import ImageList from '@mui/material/ImageList';
import ImageListItem from '@mui/material/ImageListItem';
import CardSys from "../cardSys";
import CloseIcon from "@mui/icons-material/Close";
import CardHeader from "../generic/cardHeaderDashboard";
import { Container } from "@mui/system";

export default function ModalManual({ imageUrls, open, handleClose }) {
    const { HandleFilter } = setImageManual()
    const newArr = HandleFilter({ list: '', value: '' })

    return (
        <ModalSys open={open} handleClose={handleClose}>
            <Box
                sx={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    flexDirection: "column",
                    height: "83vh",
                    width: "86vw",
                    padding: "20px"
                }}
            >
                <CardSys sx={{ width: "100%", height: "auto", overflow: "auto", }}>
                    <Container disableGutters maxWidth={false} >
                        <Box
                            sx={{
                                display: "flex",
                                flexDirection: "row-reverse",
                            }}
                        >
                            <IconButton
                                sx={{ m: 0, p: 0, zIndex: 10000 }}
                                onClick={handleClose}
                            >
                                <CloseIcon />
                            </IconButton>
                        </Box>
                    </Container  >
                    <Box sx={{ display: "flex", flexDirection: "column", height: "100%", width: "100%", overflowX: "hidden", overflowY: "auto" }}>

                        <Grid container>
                            {newArr?.map((item, index) => (
                                <Grid item key={index} xs={12}>
                                    <img
                                        src={`${item}`}
                                        srcSet={`${item}`}
                                        width="100%"
                                        // alt={item.title}
                                        loading="lazy"
                                    />
                                </Grid>
                            ))}
                        </Grid>
                    </Box>
                </CardSys>

            </Box>

        </ModalSys >
    )
}
